import { render, staticRenderFns } from "./LoadingSpinner.vue?vue&type=template&id=55cb73a4"
import script from "./LoadingSpinner.vue?vue&type=script&lang=js"
export * from "./LoadingSpinner.vue?vue&type=script&lang=js"
import style0 from "./LoadingSpinner.vue?vue&type=style&index=0&id=55cb73a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports